export function normalizeToken(token) {
  return typeof token === 'string' ? token.trim() : '';
}

export function hasToken(token) {
  return !!normalizeToken(token);
}

/** Build a path that keeps the access token in the URL. */
export function tokenPath(token, ...segments) {
  const normalized = normalizeToken(token);
  if (!normalized) return '/';

  const base = `/${encodeURIComponent(normalized)}`;
  const rest = segments
    .filter((segment) => segment != null && String(segment).length > 0)
    .map((segment) => String(segment).replace(/^\/+|\/+$/g, ''))
    .filter(Boolean);

  return rest.length ? `${base}/${rest.join('/')}` : base;
}
